// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1nALB","emails":"CreateEditClinics_emails__2mKyt","emailTagLabel":"CreateEditClinics_emailTagLabel__3Y7PG"};